import styled from "@emotion/styled";

import { setFullViewportWidthStyles, theme } from "shared/lib/styles";

import { Container as FooterContainer } from "scmp-app/components/plus/footer/style";

export const Container = styled.div`
  display: none;

  ${theme.breakpoints.up("tablet")} {
    position: relative;

    display: block;

    ${setFullViewportWidthStyles()}
    padding-block-start: 12px;
  }

  ${FooterContainer} {
    position: fixed;
    inset-block-end: 0;
  }
`;

export const PlaceholderContainer = styled.div`
  position: absolute;
  inset-block-start: 0;

  inline-size: 100%;
`;

export const Wrapper = styled.div`
  display: flex;
  flex-direction: row;
  gap: 32px;

  inline-size: 100%;
  max-inline-size: 1272px;
  margin: auto;

  ${theme.breakpoints.up("tablet")} {
    padding-inline: 32px;
  }
`;

export const Left = styled.div`
  position: fixed;
  inset-block-start: 160px;
  z-index: 1;

  inline-size: 364px;
`;

export const Right = styled.div`
  flex: 1;

  margin-inline-start: 372px;
`;
